import {
    GET_INTERNSHIPS_FAIL,
    GET_INTERNSHIPS_SUCCESS,
    ADD_INTERNSHIP_SUCCESS,
    ADD_INTERNSHIP_FAIL,
    UPDATE_INTERNSHIP_SUCCESS,
    UPDATE_INTERNSHIP_FAIL,
    DELETE_INTERNSHIP_SUCCESS,
    DELETE_INTERNSHIP_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    internships: [],
    error: null,
    loading: true
};

const internshipReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des interships
        case GET_INTERNSHIPS_SUCCESS:
            return {
                ...state,
                internships: action.payload, // tableau d'objets intership
                loading: false,
                error: null
            };

        case GET_INTERNSHIPS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une intershipe
        case ADD_INTERNSHIP_SUCCESS:
            return {
                ...state,
                internships: [action.payload, ...state.internships], // ajoute au début du tableau
                error: null
            };

        case ADD_INTERNSHIP_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une intershipe
        case UPDATE_INTERNSHIP_SUCCESS:
            return {
                ...state,
                internships: state.internships.map(internship =>
                    internship.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet intership
                        : internship
                ),
                error: null
            };

        case UPDATE_INTERNSHIP_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une intershipe
        case DELETE_INTERNSHIP_SUCCESS:
            return {
                ...state,
                internships: state.internships.filter(
                    internship => internship.id !== action.payload
                ),
                error: null
            };


        case DELETE_INTERNSHIP_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default internshipReducer;
